// DO NOT USE THE SAFEDATA FROM THIS CONTEXT
// I want to just remove all of this altogether but that doesn't, then there are errors
// about wbindgen_malloc ... so I've restored it and need to come back around to investigate later

import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import * as wasmModule from 'sched';
import LoadingSpinner from './components/common/LoadingSpinner';

// Define the context value type
interface DataManagerContextValue {
  // safeData: SafeDataWrapper;
  isLoading: boolean;
  error: string | null;
}

class SafeDataWrapper {
  safeData: wasmModule.SafeData

  constructor(safeData: wasmModule.SafeData) {
    if ((safeData as any).__wbg_ptr === 0) {
      throw new Error("tried to init with null pointer")
    }

    this.safeData = safeData;
  }

  inner() {
    if ((this.safeData as any).__wbg_ptr === 0) {
      throw new Error("tried to access inner with null pointer")
    }

    return this.safeData;
  }
}

// Create the context with a default value
const DataManagerContext = createContext<DataManagerContextValue>({} as any);

// Provider component
export const DataManagerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [safeData, setSafeData] = useState<SafeDataWrapper | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Use a ref to track if initialization has already happened
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Skip initialization if it has already been done
    if (hasInitialized.current) return;

    // Initialize WASM module and create manager
    const initializeWasm = async () => {
      try {
        // Set the flag to prevent re-initialization in StrictMode
        // (which renders the component twice as a safety check)
        hasInitialized.current = true;

        // Initialize the WASM module
        await wasmModule.default();
        console.log('WASM module initialized successfully');

        // Initialize the SafeData instance
        if (wasmModule.SafeData) {
          try {
            const safeDataInstance = new wasmModule.SafeData();
            console.log('SafeData initialized successfully:', safeDataInstance);
            const safeData = new SafeDataWrapper(safeDataInstance)
            setSafeData(safeData);
          } catch (err) {
            console.error('Failed to initialize SafeData:', err);
            setError(`Failed to initialize SafeData: ${err instanceof Error ? err.message : String(err)}`);
          }
        } else {
          console.error('SafeData not found in WASM module');
          setError('SafeData not found in WASM module');
        }

        setIsLoading(false);
      } catch (err) {
        console.error('Failed to initialize WASM:', err);
        setError(`Failed to initialize WASM module: ${err instanceof Error ? err.message : String(err)}`);
        setIsLoading(false);
      }
    };

    initializeWasm();
  }, []);

  if (!safeData || (safeData as any).__wbg_ptr === 0) {
    return (
      // TODO could show the logo here
      <LoadingSpinner />
    );
  }

  return (
    <DataManagerContext.Provider value={{ isLoading, error }}>
      {children}
    </DataManagerContext.Provider>
  );
};

// Custom hook to use the data manager context
export const useDataManager = () => useContext(DataManagerContext);
